import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function PersonalfragebogenNachrichtField() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <form.AppField name="speicheroptionen.personalfragebogenNachricht">
      {(field) => (
        <field.TextAreaInput
          label={t(
            'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalfragebogen.nachricht.label',
            {
              vorname: form.state.values.person.persoenliches.vorname,
              nachname: form.state.values.person.persoenliches.nachname,
            },
          )}
          maxLength={250}
          showCounter
        />
      )}
    </form.AppField>
  );
}
